import Vue from 'vue';
import VueRouter from 'vue-router';
import util from '../assets/js/util';
import store from '../store';
import routes from './modules';
import axios from 'axios';
import jsonwebtoken from 'jsonwebtoken';
import Cookies from 'js-cookie';
import { initMenu } from '@/assets/js/routerUtil';

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) { // 滚动条定位到顶部
    if (savedPosition) return savedPosition;
    else return { x: 0, y: 0 };
  }
});
const whiteList = ['/login', '/login/resetOrModifyPassword', '/404', '/401'];
// 获取用户token
const hasToken = function () {
  const token = Cookies.get('Admin-token', { domain: process.env.VUE_APP_TOKEN_DOMAIN });
  return !!token;
};
// const prefixProtocol = ((document.location.protocol == 'https:') ? ' https://' : ' http://');// 根据环境配置协议
// // 同步用户信息
// const registerUser = function (next) {
//   axios.get(`${prefixProtocol + process.env.VUE_APP_HOST}/user_handle/v2/sync`, { headers: { 'Authorization': `Bearer ${localStorage.JWT_TOKEN}` } })
//     .then(function (res) {
//       next();
//     }).catch(function (error) {
//       if (error.response.data.code == 401 || error.response.data.code == 402) {
//         alert('服务器响应异常（状态：002），请重新登录系统！');
//         localStorage.JWT_TOKEN = '';
//         localStorage.YK_TICKET = '';
//         if (!localStorage.YK_TICKET) loginOut();
//       } else if (error.response.data.msg) alert(error.response.data.msg);
//       else alert('服务器响应异常（状态：001），请刷新页面，重新尝试！');
//       next();
//     });
// };
// 检查浏览器是否支持正常存储 localStorage
const storageTest = function () {
  try {
    localStorage.setItem('key', 'value');
    localStorage.removeItem('key');
    return true;
  } catch (e) {
    return false;
  }
};
function loginOut () {
  window.location.href = process.env.VUE_APP_CAS_OUT;
}
router.beforeEach((to, from, next) => { /* 路由发生变化修改页面title */
  // document.title = `后台管理系统-${to.meta.title || '管理后台'}`;
  document.title = '91管理系统';
  if (hasToken()) {
    // has token
    // 如果有token 并且还去再login 页面的话，直接重定向为主页
    if (to.path == '/login' || to.path == '/login/resetOrModifyPassword') {
      next('/');
    } else {
      if (store.getters.roles.length === 0 && to.path.indexOf('/401') == -1) {
        store.dispatch('GetMenuList').then(res => {
          initMenu(router, res);
          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
        }).catch((error) => {
          // 获取菜单出错或者没有权限
          console.log('error', error);
          initMenu(router, []);
          // 如果 error.response.data.code == 401 就不用管了，因为直接跳转login页面了
          if (error.response.status !== 401) {
            next('/401');
          }
        });
      } else {
        next();
      }
    }
  } else {
    // no token
    // 如果没有token 并且是 login 页面的话，就直接放行
    if (whiteList.indexOf(to.path) !== -1) return next();
    next('/login');
  }
});

export default router;
